<template>
  <div class="activityCompletion flexcenter">
    <transition>
      <div class="activity flexcenter modal-section">
        <div class="activityTitle">
          <h3>前のアクティビティをもう一度、始めから順番に行うことをお勧めします。</h3>
        </div>
        <div class="number-list-wrap">
          <ul class="number-list">
            <li v-for="(row, rowIndex) in questionIconList">
              <span class="num" :class="row.iconClass"></span>
            </li>
          </ul>
        </div>
        <div class="activityContent">
          <div class="activityScore flexcenter">
            <div class="item align-center">
              <div>正解率</div>
              <div class="answerRate textorange"><span class="font60">{{ answerRate }}</span><span class="font30">%</span></div>
            </div>
            <div class="item">
              <ul class="score-list">
                <li class="flexbetween"><span class="ok align-left">正解</span><span class="align-right">{{ ok }}</span></li>
                <li class="flexbetween"><span class="ng align-left">不正解</span><span class="align-right">{{ ng }}</span></li>
                <li class="flexbetween"><span class="skip align-left">スキップ</span><span class="align-right">{{ skip }}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="activityFooter">
          <div class="buttons flexbetween">
            <div class="buttons-top">
              <button type=button v-on:click="clickButton('repeatSection')" class="retry">前のセクションを繰り返す</button>
            </div>
            <button type=button v-on:click="clickButton('home')" class="home">ホーム</button>
            <button type=button v-on:click="clickButton('nextSection')" class="continue">次のセクションに進む</button>
            
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'
import * as constants from '@/store/constants'

export default {
  name: 'SectionDialog',
  props: {
    answerRate: Number,
    ok: Number,
    ng: Number,
    skip: Number,
    pathScore: Array,
  },
  data () {
    return {
      questionIconList: [],
    }
  },
  mixins: [
    common,
  ],
  methods: {
    clickButton: function(kind) {
      this.log("SectionDialog clickButton kind: " + kind)
      this.$emit('clickButton', kind)
    }
  },
  created: function() {
    this.log("SectionDialog start created")
    // 問題アイコン表示
    if (this.pathScore) {
      for (var i = 0; i < this.pathScore.length; i++) {
        var iconClass = ''
        switch (this.pathScore[i].status) {
          case constants.PATHSTEP_STATE_COMPLETED:
            // 全問正解
            iconClass = 'gone'
            break;
          case constants.PATHSTEP_STATE_IN_PROGRESS:
            // 1つ以上正解
            iconClass = 'going'
            break;
          default:
            // 1つも正解がない
            iconClass = 'pending'
            break;
        }
        this.questionIconList.push({
          iconClass: iconClass
        })
      }
    }
  },
  mounted: function() {
    this.log("SectionDialog start mounted")
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// SectionDialog.vue?4e90d45e